// extracted by extract-css-chunks-webpack-plugin
module.exports = {"trendingListPanel":"Vq-GV"};